import { combineReducers } from '@reduxjs/toolkit';
import membersSlice from './members/membersSlice';
import rolesSlice from './roles/rolesSlice';

const usersSlice = combineReducers({
    members: membersSlice,
    roles: rolesSlice,
});

export default usersSlice;
